/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateUserSessionIssuerCimdClientForm,
  CreateUserSessionIssuerCimdClientForm$Outbound,
  CreateUserSessionIssuerCimdClientForm$outboundSchema,
} from "../components/createusersessionissuercimdclientform.js";

export type CreateOrganizationUserSessionIssuerCimdClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateOrganizationUserSessionIssuerCimdClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createUserSessionIssuerCimdClientForm: CreateUserSessionIssuerCimdClientForm;
};

/** @internal */
export type CreateOrganizationUserSessionIssuerCimdClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateOrganizationUserSessionIssuerCimdClientSecurity$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationUserSessionIssuerCimdClientSecurity$Outbound,
    CreateOrganizationUserSessionIssuerCimdClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createOrganizationUserSessionIssuerCimdClientSecurityToJSON(
  createOrganizationUserSessionIssuerCimdClientSecurity:
    CreateOrganizationUserSessionIssuerCimdClientSecurity,
): string {
  return JSON.stringify(
    CreateOrganizationUserSessionIssuerCimdClientSecurity$outboundSchema.parse(
      createOrganizationUserSessionIssuerCimdClientSecurity,
    ),
  );
}

/** @internal */
export type CreateOrganizationUserSessionIssuerCimdClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateUserSessionIssuerCimdClientForm:
    CreateUserSessionIssuerCimdClientForm$Outbound;
};

/** @internal */
export const CreateOrganizationUserSessionIssuerCimdClientRequest$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationUserSessionIssuerCimdClientRequest$Outbound,
    CreateOrganizationUserSessionIssuerCimdClientRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      createUserSessionIssuerCimdClientForm:
        CreateUserSessionIssuerCimdClientForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        createUserSessionIssuerCimdClientForm:
          "CreateUserSessionIssuerCimdClientForm",
      });
    }),
  );

export function createOrganizationUserSessionIssuerCimdClientRequestToJSON(
  createOrganizationUserSessionIssuerCimdClientRequest:
    CreateOrganizationUserSessionIssuerCimdClientRequest,
): string {
  return JSON.stringify(
    CreateOrganizationUserSessionIssuerCimdClientRequest$outboundSchema.parse(
      createOrganizationUserSessionIssuerCimdClientRequest,
    ),
  );
}
